import { combineReducers } from "@reduxjs/toolkit";
import type { PackageSearchState } from "@tenant/packages";
import type { PackageFlightState } from "../features/flights/store";
import packageFlightReducer from "../features/flights/store/slice";
import type { PackageHotelState } from "../features/hotels/store";
import packageHotelReducer from "../features/hotels/store/slice";
import packageSearchReducer from "../features/search/store/slice";

export type PackageState = {
  packages: {
    search: PackageSearchState;
    hotel: PackageHotelState;
    flight: PackageFlightState;
  };
};

const packageRootReducer = combineReducers({
  search: packageSearchReducer,
  hotel: packageHotelReducer,
  flight: packageFlightReducer,
});

export const packagesReducers = {
  packages: packageRootReducer,
};
